const siteConfig = {
  brandName: "yorthmarketco",
  legalName: "ACK MARKETS LIMITED",
  logo: {
    type: "wordmark",
    value: "YORTHMARKETCO",
  },
  description:
    "Independent everyday clothing shaped by useful proportions, tactile materials and thoughtful construction.",
  contact: {
    email: "logic@yorthmarketco.online",
    address: "Rm 701, Unit 108B, 7/F, Twr B New Mandarin Plaza, 14 Science Museum Rd, Tsim Sha Tsui, Hong Kong",
    addressLines: [
      "Rm 701, Unit 108B, 7/F,",
      "Twr B New Mandarin Plaza",
      "14 Science Museum Rd",
      "Tsim Sha Tsui",
      "Hong Kong",
    ],
  },
  currency: {
    code: "USD",
    locale: "en-US",
    symbol: "$",
  },
  shipping: {
    standard: 18,
    freeThreshold: 350,
  },
};

export const formatPrice = (value) =>
  `${siteConfig.currency.symbol}${new Intl.NumberFormat(
    siteConfig.currency.locale,
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  ).format(Number(value))}`;

export default siteConfig;
